export default __webpack_public_path__ + "static/media/README.cad80320.md";